/**
 * @generated SignedSource<<fb2ab30f5d63208bd290e81ac0e7af93>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaperDetailViewMutation$variables = {
  id: string;
};
export type PaperDetailViewMutation$data = {
  readonly viewPaper: {
    readonly id: string;
  };
};
export type PaperDetailViewMutation = {
  response: PaperDetailViewMutation$data;
  variables: PaperDetailViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Paper",
    "kind": "LinkedField",
    "name": "viewPaper",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaperDetailViewMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PaperDetailViewMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1c06855fa8ee1cf4aa49913728ebd007",
    "id": null,
    "metadata": {},
    "name": "PaperDetailViewMutation",
    "operationKind": "mutation",
    "text": "mutation PaperDetailViewMutation(\n  $id: ID!\n) {\n  viewPaper(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "10aea483344b1be3769ddee9c634aec0";

export default node;
